<script setup lang="ts">
import { computed } from "vue";
import DatasetAvatar from "./DatasetAvatar.vue";
const props = defineProps<{
  datasets: { id: string; name: string; write_state?: string }[];
  allowed: string[];
}>();
const scopes = defineModel<string[]>("scopes", { required: true });
const datasetIds = defineModel<string[] | null>("datasetIds", {
  required: true,
});
const all = computed({
  get: () => datasetIds.value === null,
  set: (value) => {
    datasetIds.value = value ? null : [];
  },
});
const labels: Record<string, { title: string; description: string }> = {
  "data:read": {
    title: "Læs og analysér",
    description: "Find datasæt, hent rækker og beregn resultater.",
  },
  "data:write": {
    title: "Tilføj og redigér",
    description: "Opret, opdatér, slet og gendan rækker.",
  },
  "data:manage": {
    title: "Administrér datasæt",
    description:
      "Opret og redigér datasæt og schemaer. Arkivér og slet datasæt permanent med din bekræftelse.",
  },
};
</script>
<template>
  <fieldset class="mcp-permissions">
    <legend>Hvad må forbindelsen?</legend>
    <label v-for="scope in props.allowed" :key="scope" class="mcp-choice">
      <input v-model="scopes" type="checkbox" :value="scope" />
      <span
        ><strong>{{ labels[scope]?.title }}</strong
        ><small>{{ labels[scope]?.description }}</small></span
      >
    </label>
  </fieldset>
  <fieldset class="mcp-permissions">
    <legend>Hvilke data må den bruge?</legend>
    <label class="mcp-choice"
      ><input v-model="all" type="checkbox" /><span
        ><strong>Hele mit workspace</strong
        ><small
          >Alle nuværende og kommende datasæt, som du har adgang til.</small
        ></span
      ></label
    >
    <div v-if="!all" class="mcp-dataset-choices">
      <label v-for="d in props.datasets" :key="d.id" class="mcp-choice"
        ><input
          v-model="datasetIds"
          type="checkbox"
          :value="d.id"
        /><DatasetAvatar :dataset="d" :size="20" /><span
          >{{ d.name
          }}<small v-if="d.write_state === 'archived'"
            >Arkiveret · kun læsning og eksport</small
          ></span
        ></label
      >
      <p v-if="!props.datasets.length" class="muted">
        Der er endnu ingen datasæt. Vælg hele workspace for at kunne komme i
        gang.
      </p>
      <p v-else-if="!datasetIds?.length" class="muted small">
        Vælg mindst ét datasæt.
      </p>
    </div>
  </fieldset>
</template>
